module.exports = __webpack_public_path__ + "0b9c6a7c807ed0ac36b7f42a8134b12a.jpg";